export const learningPathsCreateReducer = {};
